import PropTypes from 'prop-types'

import StoreItem from './StoreItem'

const StoreList = ({ stores = [], currentTerm }) => {
  const listCurrentStores = () => {
    return stores.map(
      (store, index) =>
        <StoreItem key={index} {...store} currentTerm={currentTerm} />)
  }

  return (
    <div className="store-list padding-x-small">
      <ul className="store-list-results">
        { listCurrentStores() }
      </ul>
    </div>
  )
}

StoreList.propTypes = {
  stores: PropTypes.arrayOf(PropTypes.object)
}

export default StoreList
